import {XSRF} from "components/src/auth/Xsrf";
import {forwardRef, useRef} from "react";

interface NoProps {
}

export const LogoutForm = forwardRef<HTMLButtonElement, NoProps>((_, logoutSubmitButtonRef) =>
{
    /**
     * A ref to the hidden _csrf form field
     */
    const csrFieldRef = useRef<HTMLInputElement>(null);

    function onSubmit()
    {
        if (csrFieldRef.current !== null) {
            csrFieldRef.current.value = XSRF.getCookie();
        }
    }

    return (
        <form method="post" action="/api/logout" onSubmit={onSubmit} className="d-none">
            <button ref={logoutSubmitButtonRef} type="submit" className="invisible"/>

            <input name="_csrf" type="hidden" ref={csrFieldRef} value=""/>
        </form>
    )
})

// see https://github.com/jsx-eslint/eslint-plugin-react/blob/master/docs/rules/display-name.md why this is needed
LogoutForm.displayName="LogoutForm"